import React from 'react';
import {connect} from 'react-redux';
import EmbedViewDisabledHandler from './EmbedViewDisabledHandler';
import styles from './EmbedCardHandler.css?module';
import {loadPublicEmbedCardById} from 'state/card/cardActions';
import {
  loadCardStateFromView,
  loadQuerystringCardFiltersById,
} from 'state/cardFilter/cardFilterActions';
import {selectIsLoadingCardFilters} from 'state/cardFilter/cardFilterSelectors';
import {loadLayoutFrameStyles} from 'state/layoutFrame/layoutFrameActions';
import './EmbedSummaryNumberOverrides.css';
import {analyticsTrack} from 'utilities/analytics';
import {ADOBE_ANALYTICS_EVENTS} from 'app/Analytics';
import {selectIsCardAccessDenied} from 'state/card/cardSelectors';
import {isInIframe} from 'utilities/userAgent';
import {parseQuerystring} from 'utilities/URL';

class EmbedCardHandler extends React.Component {
  state = {
    hasFilters: false,
  };

  componentDidMount() {
    this.load(this.props);
  }

  load(props) {
    props.loadPublicEmbedCardById(props.cardId);
    const query = parseQuerystring();
    this.setState({hasFilters: false});

    if (query.pfilters) {
      this.setState({hasFilters: true});
      props.loadQuerystringCardFiltersById(this.props.cardId);
    } else if (props.viewId) {
      this.setState({hasFilters: true});
      props.loadCardStateFromView(props.viewId, props.cardId);
    }

    this.trackPublicEmbeddedView(props.cardId, !isInIframe);

    props.loadLayoutFrameStyles(props.frameStyleId);
  }

  trackPublicEmbeddedView(cardId, isLandingPage) {
    analyticsTrack(ADOBE_ANALYTICS_EVENTS.PUBLIC__CARD__VIEW, {
      card_id: cardId,
      is_landing_page: isLandingPage,
    });
  }

  render() {
    const {isAccessDenied, children, isLoadingCardFilters} = this.props;
    const {hasFilters} = this.state;

    if (hasFilters && isLoadingCardFilters) return null;

    return isAccessDenied ? (
      <EmbedViewDisabledHandler />
    ) : (
      <div className={styles.container}>{children}</div>
    );
  }
}

export default connect(
  (state, {cardId}) => ({
    isAccessDenied: selectIsCardAccessDenied(state, cardId),
    isLoadingCardFilters: selectIsLoadingCardFilters(state, cardId),
  }),
  {
    loadPublicEmbedCardById,
    loadCardStateFromView,
    loadQuerystringCardFiltersById,
    loadLayoutFrameStyles,
  }
)(EmbedCardHandler);
